import { IBaseCellsProps } from '../../cells.interfaces';
import { StyledTableCell } from '../../CellCheckbox/CellCheckbox.styles';
import { Checkbox } from '../../../../base-components';

const CellCheckboxSkeleton = (props: IBaseCellsProps) => {
    const {
        alignment,
        columnIndex,
        isRowSelected,
        stickyColumn,
        rowStickyWidths,
    } = props;
    return (
        <StyledTableCell
            alignment={alignment}
            columnIndex={columnIndex}
            isSelected={isRowSelected}
            rowStickyWidths={rowStickyWidths}
            stickyColumn={stickyColumn}
            isHeaderCell={false}
        >
            <Checkbox color="primary" size="small" disabled />
        </StyledTableCell>
    );
};

export default CellCheckboxSkeleton;
